const IMG = "https://wewonderevents.com/wp-content/uploads";

export const GALLERY_CATEGORY_SLUG = "gallery";

export const WP_FILTER_SLUGS = {
  corporate: "corporate",
  "government-psu": "government",
  entertainment: "entertainment",
  "social-events": "social",
  "exhibitions-activations": "exhibitions",
};

export const ALBUM_FILTERS = [
  { id: "all", label: "All" },
  { id: "corporate", label: "Corporate" },
  { id: "government", label: "Government & PSU" },
  { id: "entertainment", label: "Entertainment" },
  { id: "social", label: "Social Events" },
  { id: "exhibitions", label: "Exhibitions & Activations" },
];

export const CATEGORY_LABELS = Object.fromEntries(ALBUM_FILTERS.map((f) => [f.id, f.label]));

import albumsData from "@/data/albums.json";

export const GALLERY_ALBUMS = albumsData;

export const GALLERY_HERO_IMAGE = "/gallery/live-shows/01.jpg";
